import {
  appendRow,
  ensureTab,
  getRows,
  updateRow,
} from '../lib/googleSheets';

export const RSVP_SHEET = 'RSVP';

export const RSVP_HEADERS = [
  'id',
  'created_at',
  'updated_at',
  'deleted_at',
  'guest_name',
  'email',
  'attendance',
  'guest_count',
  'dietary_requirements',
  'message',
];

const rowToRsvp = (row = []) => RSVP_HEADERS.reduce(
  (record, header, index) => ({
    ...record,
    [header]: row[index] ?? '',
  }),
  {},
);

const rsvpToRow = (rsvp) => RSVP_HEADERS.map((header) => rsvp[header] ?? '');

export async function createRsvp(input) {
  await ensureTab(RSVP_SHEET, RSVP_HEADERS);

  const timestamp = new Date().toISOString();
  const rsvp = {
    id: crypto.randomUUID(),
    created_at: timestamp,
    updated_at: timestamp,
    deleted_at: '',
    guest_name: input.guest_name.trim(),
    email: input.email.trim(),
    attendance: input.attendance,
    guest_count: String(input.guest_count || '1'),
    dietary_requirements: input.dietary_requirements.trim(),
    message: input.message.trim(),
  };

  await appendRow(`${RSVP_SHEET}!A:Z`, rsvpToRow(rsvp));
  return rsvp;
}

export async function getRsvps() {
  await ensureTab(RSVP_SHEET, RSVP_HEADERS);
  const rows = await getRows(`${RSVP_SHEET}!A2:Z`);
  return rows
    .map(rowToRsvp)
    .filter((rsvp) => !rsvp.deleted_at);
}

export async function getRsvp(id) {
  const ids = await getRows(`${RSVP_SHEET}!A:A`);
  const index = ids.findIndex((row, rowIndex) => (
    rowIndex > 0 && row?.[0] === id
  ));

  if (index < 0) {
    return null;
  }

  const rows = await getRows(`${RSVP_SHEET}!A${index + 1}:Z${index + 1}`);
  return rowToRsvp(rows[0]);
}

export async function updateRsvp(id, changes) {
  const ids = await getRows(`${RSVP_SHEET}!A:A`);
  const index = ids.findIndex((row, rowIndex) => (
    rowIndex > 0 && row?.[0] === id
  ));

  if (index < 0) {
    throw new Error('The requested RSVP could not be found.');
  }

  const currentRows = await getRows(
    `${RSVP_SHEET}!A${index + 1}:Z${index + 1}`,
  );
  const current = rowToRsvp(currentRows[0]);
  const updated = {
    ...current,
    ...changes,
    updated_at: new Date().toISOString(),
  };

  await updateRow(
    `${RSVP_SHEET}!A${index + 1}:Z${index + 1}`,
    rsvpToRow(updated),
  );

  return updated;
}

export async function deleteRsvp(id) {
  return updateRsvp(id, {
    deleted_at: new Date().toISOString(),
  });
}